import { useState } from 'react';
import Link from '@/components/base/TransitionLink';
import { brand, navLinks } from '@/mocks/home';
import SectionLink from '@/components/base/SectionLink';

export default function Header() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <header className="absolute inset-x-0 top-0 z-50" translate="no">
      <div className="mx-auto flex h-16 w-full max-w-[1440px] items-center justify-between px-5 md:h-20 md:px-10 lg:px-20">
        <Link to="/" className="cursor-target cursor-pointer whitespace-nowrap text-xl font-normal tracking-tight text-foreground-950">
          {brand.name}
          <span className="ml-1 font-light text-foreground-600">/</span>
        </Link>

        <nav className="hidden items-center gap-10 md:flex">
          {navLinks.map((l) => (
            <SectionLink key={l.href} section={l.href} onClick={close} className="link-line cursor-target cursor-pointer whitespace-nowrap pb-0.5 text-sm text-foreground-900 hover:text-primary-500 focus-visible:text-primary-500">
              {l.label}
            </SectionLink>
          ))}
          <Link
            to="/contact"
            className="group cursor-target cursor-pointer whitespace-nowrap bg-primary-500 px-4 py-2.5 text-sm text-background-50 transition-colors duration-200 hover:bg-primary-600"
          >
            Discuss a Workflow <span className="cta-arrow">&rarr;</span>
          </Link>
        </nav>

        <button
          data-cursor-target="true"
          type="button"
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center whitespace-nowrap text-foreground-950 md:hidden"
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
        </button>
      </div>

      {open && (
        <div className="border-y border-background-200 bg-background-50 px-4 pb-6 md:hidden">
          {navLinks.map((l) => (
            <SectionLink
              key={l.href}
              section={l.href}
              onClick={close}
              className="block cursor-pointer border-b border-background-200 py-4 text-base text-foreground-950"
            >
              {l.label}
            </SectionLink>
          ))}
          <Link
            to="/contact"
            onClick={close}
            className="mt-6 block cursor-pointer whitespace-nowrap bg-primary-500 px-4 py-3.5 text-center text-sm text-background-50"
          >
            Discuss a Workflow &rarr;
          </Link>
        </div>
      )}
    </header>
  );
}